import { createAsyncThunk } from "@reduxjs/toolkit";

import { ReferralAPI } from "@services/endpoints/earn/Referral";

export const getReferralData = createAsyncThunk("referral/", async () => {
    const response = await ReferralAPI.getReferralData();
    return response.data;
});
